import React from 'react';
import PropTypes from 'prop-types';
import ContactElement from '../ContactElement';

export default class Call extends React.PureComponent {
  getCallLink() {
    const { phoneNumber } = this.props;
    const countryCode = '1';
    const cleanPhoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `tel:+${countryCode}${cleanPhoneNumber}`;
  }

  render() {
    const {
      phoneNumber,
      as,
      header,
      iconPosition,
      showIcon,
      buttonColor,
      className,
      fluidButton,
      buttonSize,
    } = this.props;

    return (
      <ContactElement
        contact={phoneNumber}
        link={this.getCallLink()}
        iconType={showIcon || as === 'icon' ? 'phone' : 'none'}
        as={as}
        header={header}
        className={className}
        buttonColor={buttonColor}
        iconPosition={iconPosition}
        fluidButton={fluidButton}
        buttonSize={buttonSize}
      />
    );
  }
}

Call.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  as: PropTypes.oneOf(['text', 'button', 'icon']),
  buttonColor: PropTypes.string,
  buttonSize: PropTypes.string,
  className: PropTypes.string,
  fluidButton: PropTypes.bool,
  header: PropTypes.string,
  iconPosition: PropTypes.string,
  showIcon: PropTypes.bool,
};

Call.defaultProps = {
  as: 'text',
  buttonColor: 'default',
  buttonSize: 'large',
  className: '',
  fluidButton: false,
  header: '',
  iconPosition: 'left',
  showIcon: false,
};

Call.propOptions = {
  header: ['Call Us', ''],
  buttonColor: ['primary', 'secondary', 'default'],
  iconPosition: ['left', 'top'],
};

Call.dataPropsMap = {
  phoneNumber: ['business', 'primary_location', 'phone_number'],
};
